module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/entertainment-06e42fd282dfd4eaeac5d04f38a653ac.webp";